import JobCandidateApplicationsContainer from './job_candidate_applications_container';

const JobCandidateApplications = JobCandidateApplicationsContainer;
export default JobCandidateApplications;
